import { render } from "./Page5.vue?vue&type=template&id=51ede5e3&scoped=true"
import script from "./Page5.vue?vue&type=script&lang=js"
export * from "./Page5.vue?vue&type=script&lang=js"

import "./Page5.vue?vue&type=style&index=0&id=51ede5e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ede5e3"]])

export default __exports__